import { ContainerStyled } from '@/app/components/layouts/container';
import { MenuItem } from '@/app/components/layouts/top-navigation/shared/menu-item';
import { TOP_NAV_MENU_LABEL } from '@/app/constants/top-navigation';
import type { NavMenuItemType } from '@/app/types/top-navigation';
import { cn } from '@/app/utils/cn';
import { cnva } from '@/app/utils/cnva';

const DESKTOP_TITLE = 'ดูข้อมูล';

export const MenuGroupStyled = cnva(
  'font-noto-bold text-body-1 space-y-4 text-gray-900 xl:space-y-0'
);

export interface MenuGroupProps {
  item: NavMenuItemType;
  hideTitle?: boolean;
  isModelBuyingTools?: boolean;
  isDesktop?: boolean;
  className?: string;
  onClose?: () => void;
}

export const MenuGroup = ({
  item,
  isModelBuyingTools = false,
  isDesktop = false,
  hideTitle = false,
  className,
  onClose,
}: MenuGroupProps) => {
  const isBuyingToolsOrDesktop = isModelBuyingTools || isDesktop;
  const itemTitle = item.title ?? (isDesktop ? DESKTOP_TITLE : '');
  return (
    <nav
      aria-label={item.title ?? TOP_NAV_MENU_LABEL}
      role="menubar"
      className={MenuGroupStyled({
        className: cn({ 'xl:space-y-1': !!isBuyingToolsOrDesktop }, className),
      })}
    >
      {!hideTitle && !!itemTitle && (
        <p
          className={cn(
            'text-body-2-fixed font-noto text-gray-700 xl:pb-4',
            ContainerStyled({
              size: isBuyingToolsOrDesktop ? 'none' : 'sm',
              maxWidth: 'none',
            })
          )}
        >
          {itemTitle}
        </p>
      )}
      {item.children?.map((item, index) => (
        <MenuItem
          key={`listitem${index}`}
          item={item}
          noContainer={isBuyingToolsOrDesktop}
          onClose={onClose}
        />
      ))}
    </nav>
  );
};
